import { gql } from "@apollo/client";

export const remoteApiSpecFragment = gql`
    fragment RemoteApiSpec on RemoteApiSpec {
        id
        name
        approvalState
        author
        createdAt
        customVisibilityUsersList
        description
        documentationUrl
        endpoints {
            refId
            methods
            parameters {
                ...RemoteApiSpecParam
            }
            path
        }
        host
        iconUrl
        id
        lastEditor
        localOnly
        snapkitAppId
        maxRequestSizeBytes
        maxResponseSizeBytes
        maxResponseTimeMillis
        minLensStudioVersion
        name
        orgId
        providerName
        targetPlatforms
        updatedAt
        useBuiltinLocalProcessor
        visibility
        version
    }

    fragment RemoteApiSpecParam on RemoteApiHttpRequestParameter {
        constant
        defaultValue
        location
        name
        optional
    }
`;
